import React from "react";
import ReactStars from "react-rating-stars-component";
import { Link } from "react-router-dom";
const SpecialProduct = (props) => {
  const { title, brand, totalrating, originalPrice, discountedPrice, sold, quantity, id, img } = props;

  console.log(id);
  return (
    <>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="special-product-card">
          <div className="d-flex justify-content-between">
            <div className="position-relative">
              <img
                src={img}
                className="img-fluid"
                alt="product"
                style={{ height: "300px", width: "300px", objectFit: "contain" }}
              />
              {originalPrice > discountedPrice && (
                <div className="discount-label position-absolute" style={{ top: "10px", left: "10px" }}>
                  -
                  {Math.floor(
                    ((originalPrice - discountedPrice) / originalPrice) * 100
                  )}
                  % OFF
                </div>
              )}
            </div>

            <div className="special-product-content">
              <h5 className="brand">{brand}</h5>
              <h6 className="title">{title?.substr(0, 20) + "..."}</h6>
              <ReactStars
                count={5}
                size={24}
                value={totalrating}
                edit={false}
                activeColor="#ffd700"
              />
              <p className="original-price text-muted text-decoration-line-through">
                ₹{originalPrice}
              </p>
              <p className="discounted-price fw-bold">
                ₹{discountedPrice}
              </p>

              <div className="prod-count my-3">
                <p>Products: {quantity}</p>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: (sold / (quantity + sold)) * 100 + "%" }}
                    aria-valuenow={(sold / (quantity + sold)) * 100}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              <div className="d-flex gap-10">
                <Link className="button" to={"/product/" + id}>
                  View
                </Link>
                <Link className="button" to={"/product/" + id}>
                  Buy Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialProduct;
